import { useState } from 'react';
import { useSetError } from '@src/redux/modals';

export const useCommentDraft = (
  initial: string,
  submit: (trimmedBody: string) => Promise<void>,
  errorLabel: string
) => {
  const [draft, setDraft] = useState(initial);
  const setError = useSetError();
  const trimmed = draft.trim();

  const handleSubmit = async () => {
    try {
      await submit(trimmed);
      setDraft(initial);
    } catch (e) {
      setError({ message: `Couldn't ${errorLabel}: ${e.message}`, reportError: e });
    }
  };

  return { draft, setDraft, trimmed, handleSubmit };
};
